<template>
  <Media
    size="small"
    align="middle"
    :class="['entity', { [`entity--${size}`]: size }]"
  >
    <MediaLeft
      v-if="type"
      :class="[{ 'align-self-start': $slots.body || body }]"
    >
      <Icon v-if="icon" :id="icon" :scale="iconScale" />
    </MediaLeft>
    <MediaBody>
      <div class="entity__title">
        <!-- @slot Replace the title prop -->
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div v-if="$slots.body || body" :class="bodyClass">
        <!-- @slot Replace the body prop -->
        <slot name="body">
          {{ body }}
        </slot>
      </div>
    </MediaBody>
    <MediaRight v-if="$slots.actions">
      <slot name="actions" />
    </MediaRight>
  </Media>
</template>

<script>
export default {
  props: {
    /**
     * The entity type, defines the icon:
     * `bus, inspector, external, operator`
     */
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    /**
     * The entity size:
     * `large`
     */
    size: {
      type: String,
      default: null,
    },
  },

  computed: {
    icon() {
      return [
        'line',
        'bus',
        'inspector',
        'external',
        'operator',
        'group',
      ].includes(this.type)
        ? this.type
        : null;
    },

    iconScale() {
      return this.size === 'large' ? 1.25 : 1;
    },

    bodyClass() {
      return this.size !== 'large' ? 'text-small' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.entity__title {
  font-weight: bold;
}

.entity--large {
  .entity__title {
    font-size: rem(20px);
  }
}
</style>
